import React, { useContext } from 'react'
import { AuthContext } from '../../contexts/authContext'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.css'
import CtaIcon from '../../../static/assets/icon-cta.svg'

const HomePageCta = () => {
  const { bootstrap } = useContext(AuthContext)
  const { t } = useTranslation()

  return (
    <section className={`${styles.homePageCtaWrapper} ${styles.homePageWrapper}`}>
      <div className={styles.homePageCtaContent}>
        <h1 className="_mb-4">{t('homePage.cta.title')}</h1>
        <h2 className="_mb-6">{t('homePage.cta.subtitle')}</h2>

        <button className={`${styles.homePageCtaSignupLink} _mb-6`} onClick={() => bootstrap.start({ signinRedirect: true })}>
          {t('homePage.cta.createAccount')}
        </button>
      </div>
      <CtaIcon className={styles.headerBackground} />
    </section>
  )
}

export default HomePageCta
